<script setup>
import {watch, ref} from 'vue'
import {useRoute} from 'vue-router'

const route = useRoute()
const title = ref('')

const resolveTitle = () => {
  const rawTitle = route?.meta?.title
  return typeof rawTitle === 'function' ? rawTitle(route) : rawTitle
}

watch(
  () => route?.meta?.title,
  () => {
    title.value = resolveTitle()
  },
  {immediate: true},
)

watch(
  () => route?.params,
  () => {
    title.value = resolveTitle()
  },
  {deep: true},
)
</script>

<template>
  <span>{{ title }}</span>
</template>
